import { useMutation } from '@tanstack/react-query'

import { generateBrief } from '../api'

const useGenerateBriefMutation = () => {
  return useMutation({ mutationFn: generateBrief })
}

export default useGenerateBriefMutation
